// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__711L2","title":"ClientReferral_title__3uD_s","itemText":"ClientReferral_itemText__24c6E"};